import React, { ReactElement, useMemo } from "react";
import { FunctionComponent } from "react";
import Slider from "react-slick";
import { FormattedMessage } from "react-intl";

import CustomerHistoryAction from "../../../../actions/CustomerHistoryAction";
import CustomerHistoryArticlesStore from "../../../../stores/CustomerHistoryArticlesStore";

import { ZeroResultTypes } from "shared/src/types/ZeroResultType";

import SearchResultLayout from "../../shared/article-badges/SearchResultLayout";
import { SearchResultArticle } from "../../shared/article-badges/SearchResultArticle";

import { connect } from "shared/src/stores/storeConnect";
import * as bundleSelectionUtil from "../../../../utils/BundleSelectionUtil";
import * as articleUtils from "../../../../utils/articleUtils";

import { sliderSettings } from "./ZeroResultSettings";
import { trackRecentlyViewedResult } from "../../../../utils/ZeroSearchResultTrackingUtil";
import { ArticleRenderData } from "shared/src/types/RenderData";

type RecentlyViewedSuggestionsProps = {
    customerHistoryArticleRenderData: ArticleRenderData[] | undefined | null;
    query: string | undefined | null;
};

const RecentlyViewedSuggestionsUnconnected: FunctionComponent<RecentlyViewedSuggestionsProps> = ({
    customerHistoryArticleRenderData,
    query
}: RecentlyViewedSuggestionsProps): ReactElement | null => {
    React.useEffect(() => {
        CustomerHistoryAction.loadArticles.trigger();
    }, []);

    const renderContent = (
        customerHistoryArticleRenderData: ArticleRenderData[] | null | undefined,
        query: string | null | undefined
    ) => {
        trackRecentlyViewedResult(customerHistoryArticleRenderData?.length || 0);
        if (customerHistoryArticleRenderData && customerHistoryArticleRenderData.length > 0) {
            const items = customerHistoryArticleRenderData.slice(0, 4);
            return (
                <div className="zero-result-article-suggestions zero-result-module">
                    <h3>
                        <FormattedMessage id="SD_ZERO_RESULTS_RECENTLY_VIEWED" />
                    </h3>
                    <Slider {...sliderSettings} className="mfcss_card-article-2--grid-container-flex">
                        {items.map((item, index: number) => {
                            return <div key={index}>{renderArticleCard(item, query)}</div>;
                        })}
                    </Slider>
                </div>
            );
        } else {
            return null;
        }
    };

    const renderingContent = useMemo(
        () => renderContent(customerHistoryArticleRenderData, query),
        [customerHistoryArticleRenderData, query]
    );

    return renderingContent;
};

function renderArticleCard(item: ArticleRenderData, query: string | undefined | null) {
    const id = item.variantId.bettyVariantId;
    const itemWithSeletedBundle = Object.assign({}, item, {
        selectedBundle: bundleSelectionUtil.chooseBundleToShow(item.bundles, null, undefined, query),
        bundles: articleUtils.bettyBundleIdInsteadOfBundleNumber(item.bundles, item.bundles)
    });
    return (
        <SearchResultArticle
            key={id}
            inContainer={false}
            item={itemWithSeletedBundle}
            searchResultLayout={SearchResultLayout.GRID}
            pageType={"ZERO_RESULT"}
            zeroResultType={ZeroResultTypes.RecentlyViewed}
            deprecated={false}
            showOtherBundle={false}
        />
    );
}

const RecentlyViewedSuggestions = connect(
    {
        stores: [
            [
                CustomerHistoryArticlesStore,
                (store: typeof CustomerHistoryArticlesStore) => ({
                    customerHistoryArticleRenderData: store.getCustomerHistoryArticleRenderData()
                })
            ]
        ]
    },
    RecentlyViewedSuggestionsUnconnected
);

export { RecentlyViewedSuggestionsUnconnected, RecentlyViewedSuggestions };
